const LumaTextField = {
  defaultProps: {
    placeholderEmail: 'john@smith.com'
  }
};
export default LumaTextField;